import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Chip } from "@opensea/ui-kit";
export const ProfileENSChipFragment = graphql(`
  fragment ProfileENSChip on Profile {
    ensName
  }
`);
export function ProfileENSChip(t0) {
  const $ = _c(11);
  let profileKey;
  let rest;
  if ($[0] !== t0) {
    ({
      profile: profileKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = profileKey;
    $[2] = rest;
  } else {
    profileKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== profileKey) {
    t1 = readFragment(ProfileENSChipFragment, profileKey);
    $[3] = profileKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const profile = t1;
  if (!profile.ensName) {
    return;
  }
  const t2 = `https://app.ens.domains/${profile.ensName}`;
  let t3;
  if ($[5] !== profile.ensName || $[6] !== rest) {
    t3 = <Chip {...rest}>{profile.ensName}</Chip>;
    $[5] = profile.ensName;
    $[6] = rest;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Link href={t2} variant="unstyled">{t3}</Link>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}